import { render, staticRenderFns } from "./EditMenuContainer.vue?vue&type=template&id=09310b27&scoped=true&"
import script from "./EditMenuContainer.vue?vue&type=script&lang=ts&"
export * from "./EditMenuContainer.vue?vue&type=script&lang=ts&"
import style0 from "./EditMenuContainer.vue?vue&type=style&index=0&id=09310b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09310b27",
  null
  
)

export default component.exports